import TemplateView from "../TemplateView";
import {SORT_ORDER, throttle} from "../atUtils";

export default class SortButton extends TemplateView {
    constructor($containerEl, {
        titleLabel,
        printable = false,
        onClick = (order) => {},
        throttleDelay = 300
    }) {

        super($containerEl);

        this.params = {
            printable,
            titleLabel,
            onClick,
            throttleDelay
        }

        this.state = {
            order: null,
            active: null
        }

        this.onStatePropertyChanged('active', (active) => {
            this.$el.toggleClass('active', active);
        });

        this.onStatePropertyChanged('order', (order) => {
            this.$el.toggleClass('asc', order === SORT_ORDER.ASC);
            this.$el.toggleClass('desc', order === SORT_ORDER.DESC);
        });
    }

    templateHtml() {
        return "<div class='sortButton'>" +
               "    <div class='titleLabel'><%-params.titleLabel%></div>" +
               "    <div class='arrowContainer'><% if (params.printable) { %><div class='printArrows for-print-only'><span class='asc'>&darr;</span><span class='desc'>&uarr;</span></div><% } %></div>" + // without spaces
               "</div>"
    }

    afterRender() {
        this.$titleLabel = this.find(".titleLabel");
        this.$titleLabel.text(this.params.titleLabel);
        this.$el.click(() => {
            if (this.state.order === null) {
                this.setState({
                    order: SORT_ORDER.DESC
                });
            }

            if (this.state.active) {
                this.setState({
                    order: (this.state.order === SORT_ORDER.DESC) ? SORT_ORDER.ASC : SORT_ORDER.DESC
                });
            } else {
                this.setState({
                    active: true,
                });
            }
            const throttledOnClick = throttle(this.params.onClick, this.params.throttleDelay);
            throttledOnClick(this.state.order);
        });
    }
}



// WEBPACK FOOTER //
// ./web/js/controls/SortButton.js